// NotificationDropdown: Professional dropdown for notifications
import React, { useState } from 'react';
import { useNotifications } from '../context/NotificationContext';
import { IconButton, Badge, Menu, MenuItem, ListItemText, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';


function NotificationDropdown() {
    const { notifications, unreadCount, markAsRead, connected } = useNotifications();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // notifications state is already managed by useState/useEffect above.
  return (
    <>
      <Tooltip title={connected ? 'Notifications (connected)' : 'Notifications (disconnected)'}>
        <IconButton color="inherit" onClick={handleClick}>
          {unreadCount > 0 ? (
            <Badge badgeContent={unreadCount} color="error">
              <NotificationsIcon />
            </Badge>
          ) : (
            <Badge variant="dot" color={connected ? 'success' : 'default'}>
              <NotificationsIcon />
            </Badge>
          )}
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {notifications.length === 0 ? (
          <MenuItem disabled>No notifications</MenuItem>
        ) : (
          notifications.map((note) => (
            <MenuItem key={note._id || note.id} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', bgcolor: note.unread ? 'rgba(255,0,0,0.07)' : undefined }}>
              <ListItemText
                primary={note.content || note.text}
                secondary={note.type ? `Type: ${note.type}` : undefined}
                sx={{ fontWeight: note.unread ? 700 : 400 }}
              />
              <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                {note.relatedLink && note.relatedLink.trim() !== '' ? (
                  <button style={{ fontSize: 12, color: '#1976d2', background: 'none', border: 'none', cursor: 'pointer' }}
                    onClick={() => {
                      handleClose();
                      window.open(note.relatedLink, '_blank');
                      markAsRead(note._id);
                    }}>
                    View
                  </button>
                ) : null}
                {note.unread && (
                  <button style={{ fontSize: 12, color: '#388e3c', background: 'none', border: 'none', cursor: 'pointer' }}
                    onClick={() => {
                      markAsRead(note._id);
                      handleClose();
                    }}>
                    Mark as Read
                  </button>
                )}
              </div>
            </MenuItem>
          ))
        )}
      </Menu>
    </>
  );
}

export default NotificationDropdown;
